const buttonTypes = {
	PLACE_BET: 'PLACE_BET',
	CANCEL_BET: 'CANCEL_BET',
	BET_ACCEPTED: 'BET_ACCEPTED',
	BET_LOADER: 'BET_LOADER',
	BET_CASHOUT: 'BET_CASHOUT',
}

export default buttonTypes
